export default __webpack_public_path__ + "static/media/Eleven-Logo-final.fa0c69d7.png";